import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from 'react';
import './profile.css';

// export interface IProfileProps {
// }

export default class Profile extends React.PureComponent<any, any> {
  public render() {
    return (
      <>
        <div className='contact-background'>
          <div className='info-container'>
            <div className='info-cols'>
              <div className='photo-col'>
                <div className='photo-container'>
                  <img src='/md/img/jay.jpg' className='profile-photo'/>
                </div>
              </div>
              <div className='contact-col'>
                <h4>Contact us for more information:</h4>
                <p>PHOME. (604) 464-8850</p>
                <p>MOBILE. (604) 537-4304</p>
                <p>EMAIL. 
                  <a href="mailto:jay.shaw@jayshaw.com" target="_top" className='email'>jay.shaw@jayshaw.com</a>
                </p>
                <a 
                  href='https://www.instagram.com/jayshawphotography/' 
                  className='social-icon-white'>
                    {/* <img src='/insta-w.svg'/><p>@jayshawphotography</p> */}
                    <FontAwesomeIcon icon={faInstagram} size={'2x'}/><p>@jayshawphotography</p>
                </a>
              </div>
              <div className='profile-col-small'>
                <h4>Some of our clients:</h4>
                <ul>
                  <li>Architectural Institute of BC</li>
                  <li>BTY</li>
                  <li>Burnaby Hospital Foundation</li>
                  <li>Branch MacMaster LLP</li>
                  <li>CHANEL</li>
                  <li>Christian Dior</li>
                  <li>City of Burnaby</li>
                  <li>CKNW Kid's Fund</li>
                  <li>Delta Hospital Foundation</li>
                  <li>Eagle Ridge Hospital Foundation</li>
                  <li>Heart & Stroke Foundation</li>
                  <li>Holt Renfrew</li>
                  <li>Kwantlen University </li>
                  <li>Louis Vuitton</li>
                  <li>Pacific Autism Family Centre</li>
                  <li>Roper Greyell LLP</li>
                  <li>St. Paul’s Hospital Foundation</li>
                  <li>Twining, Short & Haakonson, Barristers</li>
                  <li>TD Canada Trust</li>
                  <li>Westminster Savings Credit Union</li>
                </ul>
              </div>
              <div className='profile-col-big'>
                <h4>Some of our clients:</h4>
                <ul>
                  <li>Architectural Institute of BC</li>
                  <li>BTY</li>
                  <li>Burnaby Hospital Foundation</li>
                  <li>Branch MacMaster LLP</li>
                  <li>CHANEL</li>
                  <li>Christian Dior</li>
                  <li>City of Burnaby</li>
                  <li>CKNW Kid's Fund</li>
                  <li>Delta Hospital Foundation</li>
                  <li>Eagle Ridge Hospital Foundation</li>
                </ul>
              </div>
              <div className='profile-col-big clients-col2'>
                <ul>
                  <li>Heart & Stroke Foundation</li>
                  <li>Holt Renfrew</li>
                  <li>Kwantlen University </li>
                  <li>Louis Vuitton</li>
                  <li>Pacific Autism Family Centre</li>
                  <li>Roper Greyell LLP</li>
                  <li>St. Paul’s Hospital Foundation</li>
                  <li>Twining, Short & Haakonson, Barristers</li>
                  <li>TD Canada Trust</li>
                  <li>Westminster Savings Credit Union</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/bundles/profile/components/profile/profile.tsx